import { render, staticRenderFns } from "./updateDevSoftware.vue?vue&type=template&id=6440aa0d&scoped=true&"
import script from "./updateDevSoftware.vue?vue&type=script&lang=js&"
export * from "./updateDevSoftware.vue?vue&type=script&lang=js&"
import style0 from "./updateDevSoftware.vue?vue&type=style&index=0&id=6440aa0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440aa0d",
  null
  
)

export default component.exports